import type { Method, AxiosRequestConfig } from 'axios';

export type ErrorFields = Record<string, Record<string, string>>;

export interface ApiError extends Error {
  status?: number;
  fields?: ErrorFields;
  data?: Record<string, unknown>;
}

export const isApiError = (err: unknown): err is ApiError =>
  typeof err === 'object' &&
  err !== null &&
  'status' in err &&
  typeof (err as { status?: unknown }).status === 'number';

export interface ApiResponseError {
  status: number;
  message: string | ErrorFields;
  timestamp: Date;
  path: string;
  method: Method;
  code?: number;
  error?: string;
  data?: Record<string, unknown>;
}

export interface CdlError extends Error {
  status: number;
  message: string;
}

export interface AxiosCustomConfig extends AxiosRequestConfig {
  skipAuthorization?: boolean;
}
